<main class="page-main quote-compare-pdf">
  <div class="container layout layout--nicedocs">
    <div class="layout__row">
      <div class="layout__bodycol">
        @if (error) {
          <p class="text-center">This comparison could not be loaded.</p>
        } @else if (!loading) {
          <header class="nicedocs-header">
            <div class="nicedocs-header__company">
              <img src="assets/0/logo.svg" class="img-fluid" alt="Everything.Insure" />
            </div>
            <div class="nicedocs-header__title">
              <h1 class="h3">Quote Comparison</h1>
              @if (validUntil) {
                <time>Valid until {{validUntil}}</time>
              }
            </div>
          </header>

          <ng-template #tableHead>
            <thead>
              <tr>
                <th>&nbsp;</th>
                @for (col of columns; track $index) {
                  <th>{{col?.label}}</th>
                }
              </tr>
            </thead>
          </ng-template>

          <ng-template #tableSpacing>
            <tfoot>
              <tr>
                <td></td>
                @for (col of columns; track $index) {
                  <td></td>
                }
              </tr>
            </tfoot>
          </ng-template>

          <section class="nicedocs-compare">
            <table>
              <thead>
                <tr>
                  @for (col of columns; track $index) {
                    <th>
                      <div class="nicedocs-compare__head">
                        <div class="nicedocs-compare__head-company">
                          <div class="company-thumb">
                            <div class="company-thumb__img">
                              <img [src]="col?.img_path" class="img-fluid" [alt]="col?.group_name" />
                            </div>
                          </div>
                        </div>
                        <div class="nicedocs-compare__head-content">
                          <h6 class="font-16">{{col?.label}}</h6>
                          <p><strong>{{col?.value}}</strong> /{{col?.description}}</p>
                        </div>
                      </div>
                    </th>
                  }
                </tr>
              </thead>
              <tbody>
                @if (topFeatures.length) {
                  <tr>
                    <td [attr.colspan]="columns.length" class="nicedocs-compare__title"><strong>Featured</strong></td>
                  </tr>
                  @for (row of topFeatures; track row.key) {
                    <tr>
                      @for (cell of row.cells; track $index) {
                        <td class="nicedocs-compare__items">
                          <div class="nicedocs-compare__item">
                            @if (cell) {
                              <p>
                                <span>{{row.label}}</span>
                                @if (cell.value) {
                                  <span class="nowrap"><strong>{{cell.value}}</strong></span>
                                }
                              </p>
                            } @else {
                              <p class="text-color-secondary">
                                <span>{{row.label}}</span>
                                <svg class="icon icon--sm text-color-error" role="img" aria-label="Not included"><use xlink:href="#circle-small-excluded"></use></svg>
                              </p>
                            }
                          </div>
                        </td>
                      }
                    </tr>
                  }
                }

                @if (topIncluded.length) {
                  <tr>
                    <td [attr.colspan]="columns.length" class="nicedocs-compare__title"><strong>Included</strong></td>
                  </tr>
                  @for (row of topIncluded; track row.key) {
                    <tr>
                      @for (cell of row.cells; track $index) {
                        <td class="nicedocs-compare__items">
                          <div class="nicedocs-compare__item">
                            @if (cell) {
                              <p>
                                <img [src]="row.img_path || 'assets/icn/24px-generic.svg'" class="icon" alt=""
                                  (error)="$any($event.target).src = 'assets/icn/24px-generic.svg'" />
                                <span>
                                  <strong>{{row.label}}</strong>
                                  @if (cell.value && cell.value !== '-') {
                                    <span class="nowrap">Up to <strong>{{cell.value}}</strong></span>
                                  }
                                </span>
                              </p>
                            } @else {
                              <p class="text-color-secondary">
                                <img [src]="row.img_path || 'assets/icn/24px-generic.svg'" class="icon" alt=""
                                  (error)="$any($event.target).src = 'assets/icn/24px-generic.svg'" />
                                <span>
                                  <strong>{{row.label}}</strong>
                                  <svg class="icon icon--sm text-color-error" role="img" aria-label="Not included"><use xlink:href="#circle-small-excluded"></use></svg>
                                </span>
                              </p>
                            }
                          </div>
                        </td>
                      }
                    </tr>
                  }
                }

                @if (topNotIncluded.length) {
                  <tr>
                    <td [attr.colspan]="columns.length" class="nicedocs-compare__title"><strong>Not Included</strong></td>
                  </tr>
                  @for (row of topNotIncluded; track row.key) {
                    <tr>
                      @for (cell of row.cells; track $index) {
                        <td class="nicedocs-compare__items">
                          <div class="nicedocs-compare__item">
                            <p [class.text-color-secondary]="!cell">
                              <img [src]="row.img_path || 'assets/icn/24px-generic.svg'" class="icon" alt=""
                                (error)="$any($event.target).src = 'assets/icn/24px-generic.svg'" />
                              <span>
                                <strong>{{row.label}}</strong>
                                @if (cell) {
                                  <svg class="icon icon--sm text-color-error" role="img" aria-label="Not included"><use xlink:href="#circle-small-excluded"></use></svg>
                                }
                              </span>
                            </p>
                          </div>
                        </td>
                      }
                    </tr>
                  }
                }
              </tbody>
            </table>
          </section>

          @if (hasDetail) {
            <div class="nicedocs-table-head">
              <h1 class="font-serif">In more detail</h1>
            </div>

            @if (itemGroups.length) {
              <section class="nicedocs-table">
                <div class="nicedocs-table__title"><h3>Your Insured Items</h3></div>
                <table>
                  <ng-container *ngTemplateOutlet="tableHead"></ng-container>
                  <tbody>
                    @for (group of itemGroups; track group.group_id) {
                      <tr class="nicedocs-table__subhead">
                        <th><div class="nicedocs-table__cell"><p>{{group.group_name}}</p></div></th>
                        @for (cell of group.totalCells; track $index) {
                          <th>
                            <div class="nicedocs-table__cell">
                              @if (cell) { <p><strong><em>{{cell.value}}</em>.00</strong> /{{frequency}}</p> }
                            </div>
                          </th>
                        }
                      </tr>
                      @for (row of group.rows; track row.key) {
                        <tr class="nicedocs-table__row">
                          <td>
                            <div class="nicedocs-table__cell">
                              <p>{{row.title}}</p>
                              @if (row.subtitle) { <small>{{row.subtitle}}</small> }
                            </div>
                          </td>
                          @for (cell of row.cells; track $index; let c = $index) {
                            <td>
                              <div class="nicedocs-table__cell">
                                @if (cell) {
                                  <p><strong>{{cell.value}}.00</strong> /{{frequency}}</p>
                                  @if (row.more[c]) { <span class="tag tag--more">{{row.more[c]}}</span> }
                                }
                              </div>
                            </td>
                          }
                        </tr>
                      }
                    }
                  </tbody>
                  <ng-container *ngTemplateOutlet="tableSpacing"></ng-container>
                </table>
              </section>
            }

            @if (insurerRows.length) {
              <section class="nicedocs-table">
                <div class="nicedocs-table__title"><h3>The Insurers</h3></div>
                <table>
                  <ng-container *ngTemplateOutlet="tableHead"></ng-container>
                  <tbody>
                    <tr class="nicedocs-table__row">
                      <td><div class="nicedocs-table__cell"><p>Insurer Name</p></div></td>
                      @for (col of columns; track $index) {
                        <td><div class="nicedocs-table__cell"><p>{{col?.group_name}}</p></div></td>
                      }
                    </tr>
                    <tr class="nicedocs-table__row">
                      <td>
                        <div class="nicedocs-table__cell">
                          <p>Overall Rating</p>
                          <small>This rating is based on whether an insurer is good or not in the areas our customers care about.</small>
                        </div>
                      </td>
                      @for (col of columns; track $index; let c = $index) {
                        <td>
                          <div class="nicedocs-table__cell">
                            <div class="d-flex align-items-center">
                              <div class="stars">
                                @for (percent of stars(c); track $index) {
                                  <div class="stars__star">
                                    <svg class="icon"><use xlink:href="#star-inactive"></use></svg>
                                    <div class="stars__percent stars__percent--{{percent}}">
                                      <svg class="icon"><use xlink:href="#star-active"></use></svg>
                                    </div>
                                  </div>
                                }
                              </div>
                              <p class="nowrap ml-10 font-semibold">{{overall(c) | number:'1.0-1'}} stars</p>
                            </div>
                          </div>
                        </td>
                      }
                    </tr>
                    @for (rating of insurerRows; track rating.rating_type) {
                      <tr class="nicedocs-table__row">
                        <td><div class="nicedocs-table__cell"><p>{{rating.rating_type}}</p></div></td>
                        @for (cell of rating.cells; track $index) {
                          <td>
                            <div class="nicedocs-table__cell">
                              @if (cell) { <p>{{cell.value}}</p> }
                            </div>
                          </td>
                        }
                      </tr>
                    }
                  </tbody>
                  <ng-container *ngTemplateOutlet="tableSpacing"></ng-container>
                </table>
              </section>
            }

            @if (benefitGroups.length) {
              <section class="nicedocs-table">
                <div class="nicedocs-table__title"><h3>The Benefits</h3></div>
                <table>
                  <ng-container *ngTemplateOutlet="tableHead"></ng-container>
                  <tbody>
                    @for (group of benefitGroups; track group.group_id) {
                      <tr class="nicedocs-table__subhead">
                        <th><div class="nicedocs-table__cell"><p>{{group.group_name}}</p></div></th>
                        @for (col of columns; track $index) {
                          <th><div class="nicedocs-table__cell">&nbsp;</div></th>
                        }
                      </tr>
                      @for (row of group.rows; track row.key) {
                        <tr class="nicedocs-table__row">
                          <td>
                            <div class="nicedocs-table__cell">
                              <div class="d-flex">
                                <img [src]="row.img_path || 'assets/icn/24px-generic.svg'" class="icon icon--md" alt=""
                                  (error)="$any($event.target).src = 'assets/icn/24px-generic.svg'" />
                                <div class="ml-15"><p><strong>{{row.label}}</strong></p></div>
                              </div>
                            </div>
                          </td>
                          @for (cell of row.cells; track $index) {
                            <td>
                              <div class="nicedocs-table__cell">
                                @if (!cell) {
                                  <svg class="icon text-color-disabled" role="img" aria-label="Not included"><use xlink:href="#close-circle-small"></use></svg>
                                } @else if (cell.value === '-') {
                                  <svg class="icon text-color-positive" role="img" aria-label="No limit"><use xlink:href="#success-small"></use></svg>
                                } @else {
                                  <p>{{cell.value}}</p>
                                }
                                @if (cell?.description === 'Optional') { <span class="tag tag--more">Added</span> }
                              </div>
                            </td>
                          }
                        </tr>
                      }
                    }
                  </tbody>
                  <ng-container *ngTemplateOutlet="tableSpacing"></ng-container>
                </table>
              </section>
            }

            @if (coveredGroups.length) {
              <section class="nicedocs-table">
                <div class="nicedocs-table__title"><h3>What’s Covered</h3></div>
                <table>
                  <ng-container *ngTemplateOutlet="tableHead"></ng-container>
                  <tbody>
                    @for (group of coveredGroups; track group.group_id) {
                      <tr class="nicedocs-table__subhead">
                        <th><div class="nicedocs-table__cell"><p>{{group.group_name}}</p></div></th>
                        @for (col of columns; track $index) {
                          <th><div class="nicedocs-table__cell">&nbsp;</div></th>
                        }
                      </tr>
                      @for (row of group.rows; track row.key) {
                        <tr class="nicedocs-table__row">
                          <td>
                            <div class="nicedocs-table__cell">
                              <p><strong>{{row.label}}</strong></p>
                              @if (row.description) { <small>{{row.description}}</small> }
                            </div>
                          </td>
                          @for (cell of row.cells; track $index) {
                            <td>
                              <div class="nicedocs-table__cell">
                                @if (cell) {
                                  <svg class="icon text-color-positive" role="img" aria-label="Covered"><use xlink:href="#success-small"></use></svg>
                                } @else {
                                  <svg class="icon text-color-disabled" role="img" aria-label="Not covered"><use xlink:href="#close-circle-small"></use></svg>
                                }
                              </div>
                            </td>
                          }
                        </tr>
                      }
                    }
                  </tbody>
                  <ng-container *ngTemplateOutlet="tableSpacing"></ng-container>
                </table>
              </section>
            }

            @if (notCoveredGroups.length) {
              <section class="nicedocs-table">
                <div class="nicedocs-table__title"><h3>What’s Not Covered</h3></div>
                <table>
                  <ng-container *ngTemplateOutlet="tableHead"></ng-container>
                  <tbody>
                    @for (group of notCoveredGroups; track group.group_id) {
                      <tr class="nicedocs-table__subhead">
                        <th><div class="nicedocs-table__cell"><p>{{group.group_name}}</p></div></th>
                        @for (col of columns; track $index) {
                          <th><div class="nicedocs-table__cell">&nbsp;</div></th>
                        }
                      </tr>
                      @for (row of group.rows; track row.key) {
                        <tr class="nicedocs-table__row">
                          <td>
                            <div class="nicedocs-table__cell">
                              <p><strong>{{row.label}}</strong></p>
                              @if (row.description) { <small>{{row.description}}</small> }
                            </div>
                          </td>
                          @for (cell of row.cells; track $index; let c = $index) {
                            <td>
                              <div class="nicedocs-table__cell">
                                @if (cell?.value === 'Optional') {
                                  <p class="text-color-grey-6">Optional</p>
                                } @else if (cell) {
                                  <svg class="icon text-color-error" role="img" aria-label="Not covered"><use xlink:href="#close-circle-small"></use></svg>
                                } @else if (row.otherCells[c]) {
                                  <svg class="icon text-color-positive" role="img" aria-label="Covered"><use xlink:href="#success-small"></use></svg>
                                }
                              </div>
                            </td>
                          }
                        </tr>
                      }
                    }
                  </tbody>
                  <ng-container *ngTemplateOutlet="tableSpacing"></ng-container>
                </table>
              </section>
            }
          }

          <footer class="nicedocs-footer mt-35">
            <div class="nicedocs-footer__inner container-fluid">
              <div class="nicedocs-footer__logo">
                <img id="logo" src="assets/0/logo.svg" alt="Everything.Insure" />
              </div>
              <div class="nicedocs-footer__text">
                <p>
                  <strong>Questions?</strong> Contact Everything.Insure at &lt;<a href="mailto:support@everything.insure">support&#64;everything.insure</a>&gt; or call
                  <strong>011 510 1300</strong>
                </p>
                <p>Note that cover is subject to the payment of the premium and all other policy terms and conditions detailed in the schedule and wording.</p>
              </div>
            </div>
          </footer>
        }
      </div>
    </div>
  </div>
</main>
